import { createFileRoute } from "@tanstack/react-router";

import { LoadingIcon } from "@web-app/components";
import { useApp } from "@web-app/hooks";
import ChatPage from "@web-app/pages/chatPage";
import ChatEventsProvider from "@web-app/pages/chatPage/ChatEventsProvider";

export const Route = createFileRoute("/chat")({
  component: Chat,
  validateSearch: (search: Record<string, unknown>) => ({
    conversationId: (search.conversationId as string) || undefined,
  }),
});

function Chat() {
  const { sessionUser, isLoading, logout } = useApp();

  if (isLoading || !sessionUser) {
    return (
      <div className="h-screen w-screen grid place-content-center">
        <LoadingIcon className="w-8 h-8" />
      </div>
    );
  }

  return (
    <ChatEventsProvider>
      <ChatPage logout={logout} />
    </ChatEventsProvider>
  );
}
